<script lang="ts" setup>
import { useClipboardApi } from '~/composables/useClipboardApi'
import { computed, inject } from 'vue'
import { useI18n } from 'vue-i18n'
import { KsButton } from '@aschehoug/kloss'
import { PendoFeature } from '~/models/Pendo'

const ksToast = inject('ksToast') as Toast
const { t } = useI18n()
const { writeToClipboard } = useClipboardApi()

const props = withDefaults(defineProps<{
  url?: string
  stretch?: boolean
  icon?: string
  shape?: string
  variant?: string
}>(), {
  url: '',
  stretch: false,
  icon: '',
  shape: 'normal',
  variant: 'tertiary',
})

const relevantUrl = computed(() => {
  if (!props.url) {
    return '#'
  }

  if (props.url.startsWith('/')) {
    return `${import.meta.env.VITE_HOST}${props.url}`
  }

  return props.url
})

const activateCopy = () => {
  try {
    writeToClipboard({ text: relevantUrl.value })
    ksToast.success({
      message: t('copy.messages.success'),
      duration: 2000,
    })
  } catch (e) {
    ksToast.error({
      message: t('copy.messages.error'),
      duration: 5000,
    })
    throw e
  }
}

</script>
<template>
  <KsButton
    :variant="props.variant"
    :stretch="props.stretch"
    :data-pendo="PendoFeature.Card.CopyUrl"
    :icon-left="props.icon"
    :shape="props.shape"
    :center="false"
    @click.prevent="activateCopy"
  >
    {{ t('copy.copyUrl') }}
  </KsButton>
</template>
